module.exports = __webpack_public_path__ + "img/kt6.03c49b8c.png";